<template>
  <div class="mobile-page">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="ruleForm"
    >
      <el-form-item label="任务名：" prop="name" class="item">
        <el-input v-model="ruleForm.name"  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="指派谁：" prop="deliverto" class="item">
        <el-select
          v-model="ruleForm.deliverto"
          placeholder="请选择指给谁"
          clearable
          filterable
        >
          <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button> -->
    <!-- action="/api/once/upload" -->
    <el-upload
      ref="upload"
      class="upload-demo"
      action="/api/once/upload"
      name="uploadfile"
      :before-upload="beforeUpload"
      :on-progress="uploadProgress"
      :on-success="uploadSuccess"
      :on-change="onChange"
      accept=".xls,.xlsx"
      :data="ruleForm"
      :on-preview="handlePreview"
      :file-list="fileList"
      :auto-upload="false"
      :multiple="false"
      :limit="1"
      :on-remove="handleRemove"
    >
      <el-button size="small" type="primary">选择文件</el-button>
      <!-- <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div> -->
    </el-upload>

    <el-button class="submit" @click="submitUpload"  size="small" type="primary" :loading="loading">确定提交</el-button>
  </div>
</template>

<script>
import permissionMixins from '@/mixins/permission'
export default {
  mixins: [permissionMixins],
  data() {
    return {
      loading: false,
      disabled: true,
      ruleForm: {
        name: '',
        deliverto: ''
      },
      rules: {

      },
      form: {
        name: ''
      },
      prizeList: [],
      notify: {},
      userList: [
        // {
        //   value: '选项1',
        //   label: '黄金糕'
        // }
      ],
      userName: '',
      fileList: []
    }
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        // console.log(newVal)
        // if (newVal.name && newVal.deliverto) {
        //   this.disabled = false
        // } else {
        //   this.disabled = true
        // }
      },
      deep: true
    }
  },
  computed: {
    // disabled() {
    //   return !this.userName
    // }
  },
  methods: {
    submit() {},
    init() {
      this.getAllUser()
    },
    beforeUpload(file) {
      // console.log(file)
      this.loading = true
      const fileStyle = ['xls', 'xlsx']
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (!fileStyle.includes(extension)) {
        this.$message.warning('只能上传后缀是.xlsx的文件')
        return false
      } else {
        this.notify[file.uid] = this.$notify.success({
          title: '提示',
          message: file.name + ' 正在上传中，进度0%',
          duration: 0,
          showClose: false
        })
      }
    },
    uploadProgress(e, file) {
      this._progress = e.percent + '%'
      this.notify[file.uid].message = `${file.name} 正在上传中，进度${parseInt(
        this._progress
      )}%`
    },
    uploadSuccess(response, file) {
      this.loading = false
      this.notify[file.uid].close()
      if (response.status === 'success') {
        this.$message.success('上传成功')
        this.$nextTick(() => {
          console.log(1)
          this.ruleForm.name = ''
          this.ruleForm.deliverto = ''
          // this.disabled = true
          this.fileList = []
          this.$forceUpdate()
        })
      }
    },
    getAllUser() {
      this.$http
        .post('/yuangong/list3', {
          a: 1
        })
        .then((res) => {
          if (res.data.data && res.data.data.length) {
            this.userList = res.data.data
          }
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitUpload() {
      // this.$refs.upload.submit()
      if (!this.ruleForm.name) {
        this.$message.error('请输入任务名')
        return false
      }
      if (!this.ruleForm.deliverto) {
        this.$message.error('请选择指派谁')
        return false
      }
      if (this.fileList && this.fileList.length <= 0) {
        this.$message.error('请选择上传文件')
        return false
      }
      this.$refs.upload.submit()
    },

    handlePreview(file) {
      // console.log(file)
    },
    handleRemove(file, fileList) {
      this.fileList = []
    },
    // 文件选取时候，赋值表单
    onChange(file, fileList) {
      // if (!this.ruleForm.name) {
      this.ruleForm.name = file.name.split('.')[0]
      // }
      this.fileList = fileList
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss">
.mobile-page {
  padding-top: 10px;
  padding-bottom: 50px;
  width: 600px;
  .userList {
    margin-bottom: 20px;
  }
  .select {
    width: 180px;
  }
  .item {
    width: 600px;
  }
  .upload-demo{
    padding: 10px 0 0 34px;
  }
  .submit{
    margin:70px 0 0 273px;
  }
}
</style>
